import CityPageTemplate from "../city-template/CityPageTemplate";
import { phoenixConfig } from "./data";

export default function PhoenixPage() {
  return <CityPageTemplate config={phoenixConfig} />;
}